<div class="address-chips" [class.address-chips-disabled]="disabled" (click)="input.focus()">
  <span *ngFor="let address of addresses" class="address-chip" [class.address-chip-invalid]="!isValid(address)"
        [pTooltip]="isValid(address) ? '' : 'Esta dirección no parece válida'">
    <span class="address-chip-text">{{address}}</span>
    <i class="pi pi-times address-chip-remove" *ngIf="!disabled" (click)="$event.stopPropagation(); remove(address)"></i>
  </span>

  <input #input type="text" class="address-chips-input"
         [(ngModel)]="draft"
         [disabled]="disabled"
         [placeholder]="addresses.length === 0 ? placeholder : ''"
         (keydown)="onKeydown($event)"
         (paste)="onPaste($event)"
         (blur)="commit()" />
</div>
